import { gql } from '@apollo/client';

const setMcpGlobalEnabled = gql`
  mutation SetMcpGlobalEnabled($enabled: Boolean!) {
    setMcpGlobalEnabled(enabled: $enabled)
  }
`;

export default setMcpGlobalEnabled;
